import React, { useEffect } from "react";

export const StaticPage = ({ title, subtitle, lastUpdated, children, testId }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14" data-testid={testId}>
      <h1 className="font-display text-3xl sm:text-4xl font-black tracking-wider ac-gold-text">
        {title}
      </h1>
      {subtitle && <p className="text-zinc-400 text-base mt-3">{subtitle}</p>}
      {lastUpdated && (
        <p className="text-zinc-500 text-xs uppercase tracking-widest mt-2">
          Last Updated: {lastUpdated}
        </p>
      )}
      <div className="mt-8 space-y-5 text-zinc-300 leading-relaxed text-sm sm:text-base ac-static-content">
        {children}
      </div>
    </div>
  );
};

export const Section = ({ heading, children }) => (
  <section className="space-y-2">
    {heading && (
      <h2 className="font-display text-lg font-bold text-zinc-100 tracking-wide mt-6">
        {heading}
      </h2>
    )}
    {children}
  </section>
);

export const Bullets = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1 marker:ac-gold-text">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);
